import Vue from 'vue';
import Vuex from 'vuex';

import { visitors } from './visitors';
import { onboarding } from './onboarding';
import { environement } from './environement';


Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        visitors,
        onboarding,
        environement
    }
});